import { Component, OnInit, Input, ChangeDetectorRef } from "@angular/core";
import {
  DataService,
  Dialog,
  NotificationService,
  SharedModule,
} from "@bb-vendure/admin-ui/core";
import { FormBuilder, Validators } from "@angular/forms";
import {
  BulkUpdatePackageReviewDocument,
  BulkUpdateRuleDocument,
  CheckBulkUpdatePackageReviewDocument,
  CheckBulkUpdateRuleDocument,
  GetProductSplitOrderRuleDocument,
  PackageReviewsQuery,
} from "src/generated-gql/graphql";
import { ProductVariantSelectorComponent } from "../update-sku-dialog/product-variant-selector/product-variant-selector.component";
import { take, combineLatest } from "rxjs";
import { ProductSelectorComponent } from "./product-selector/product-selector.component";

@Component({
  //selector: "approve-inbound-dialog"
  templateUrl: "./bulk-update-rule-dialog.component.html",
  standalone: true,
  imports: [SharedModule, ProductSelectorComponent],
})
export class BulkUpdateRuleDialogComponent implements Dialog<boolean>, OnInit {
  resolveWith: (result?: boolean) => void;

  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private formBuilder: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {}
  ngOnInit(): void {}

  @Input()
  items: PackageReviewsQuery["packageReviews"]["items"];

  currentRule: any;

  newVariant: any;

  detailForm = this.formBuilder.group({
    productId: [null, Validators.required],
    shippingQuantity: [0, [Validators.min(0), Validators.required]],
    shippingWeight: [0, [Validators.min(0), Validators.required]],
    freeGiftQuantity: [0, [Validators.min(0), Validators.required]],
  });

  affectOrders: null | any[] = null;

  onSelectProduct(event: any) {
    if (!event) {
      this.currentRule = null;
      this.detailForm.patchValue({
        productId: null,
      });
      this.checkBulkUpdate();

      return;
    }

    this.detailForm.patchValue({
      productId: event.id,
    });

    this.dataService
      .query(GetProductSplitOrderRuleDocument, {
        id: event.id,
      })
      .single$.subscribe((res) => {
        if (res.splitOrderRuleByProductId) {
          this.currentRule = res.splitOrderRuleByProductId;
          this.checkBulkUpdate();
        }
      });
  }

  checkBulkUpdate() {
    const data = this.detailForm.value;

    if (!data.productId) {
      this.affectOrders = null;
      return;
    }

    this.dataService
      .mutate(CheckBulkUpdateRuleDocument, {
        input: {
          ids: this.items.map((i) => i.id),
          productId: data.productId!,
          shippingQuantity: data.shippingQuantity!,
          shippingWeight: data.shippingWeight!,
          freeGiftQuantity: data.freeGiftQuantity!,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        console.log("res", res);

        if (res.checkBulkUpdateRule !== null) {
          this.affectOrders = res.checkBulkUpdateRule!;
        }
      });
  }

  save() {
    const data = this.detailForm.value;

    this.dataService
      .mutate(BulkUpdateRuleDocument, {
        input: {
          ids: this.items.map((i) => i.id),
          productId: data.productId!,
          shippingQuantity: data.shippingQuantity!,
          shippingWeight: data.shippingWeight!,
          freeGiftQuantity: data.freeGiftQuantity!,
        },
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res.bulkUpdateRulePackageReview) {
          this.notificationService.success(
            `Bulk update ${res.bulkUpdateRulePackageReview.length} items sucessfully`
          );
          this.resolveWith(true);
        }
      });
  }

  cancel() {
    this.resolveWith(false);
  }
}
